// src/features/executive/sales/hooks/use-top-doctors.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  GetTopDoctorsParams,
  TopDoctorsResponse,
  ExecutiveFilterState,
} from 'api/executive/executive.types'

export function useTopDoctors(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetTopDoctorsParams, TopDoctorsResponse>(
    'sales.top-doctors',
    SalesApi.getTopDoctors,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        txCategoryId: f.txCategoryId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
        limit: 10,
      }
    },
    { scopedFilters }
  )
}
